import createIcon from '../../createIcon';

/**
 * @component @name DirectionsBusFilled
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMi41QzggMi41IDQgMyA0IDYuNVYxNkM0IDE2Ljk1IDQuMzggMTcuODEgNSAxOC40NFYyMC41QzUgMjEuMDUgNS40NSAyMS41IDYgMjEuNUg3QzcuNTUgMjEuNSA4IDIxLjA1IDggMjAuNVYxOS41SDE2VjIwLjVDMTYgMjEuMDUgMTYuNDUgMjEuNSAxNyAyMS41SDE4QzE4LjU1IDIxLjUgMTkgMjEuMDUgMTkgMjAuNVYxOC40NEMxOS42MiAxNy44MSAyMCAxNi45NSAyMCAxNlY2LjVDMjAgMyAxNi40MiAyLjUgMTIgMi41Wk04LjUgMTYuNUM3LjY3IDE2LjUgNyAxNS44MyA3IDE1QzcgMTQuMTcgNy42NyAxMy41IDguNSAxMy41QzkuMzMgMTMuNSAxMCAxNC4xNyAxMCAxNUMxMCAxNS44MyA5LjMzIDE2LjUgOC41IDE2LjVaTTE1LjUgMTYuNUMxNC42NyAxNi41IDE0IDE1LjgzIDE0IDE1QzE0IDE0LjE3IDE0LjY3IDEzLjUgMTUuNSAxMy41QzE2LjMzIDEzLjUgMTcgMTQuMTcgMTcgMTVDMTcgMTUuODMgMTYuMzMgMTYuNSAxNS41IDE2LjVaTTE4IDEwLjVINlY3LjVIMThWMTAuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DirectionsBusFilled = createIcon('DirectionsBusFilled', [
  [
    'path',
    {
      d: 'M12 2.5C8 2.5 4 3 4 6.5V16C4 16.95 4.38 17.81 5 18.44V20.5C5 21.05 5.45 21.5 6 21.5H7C7.55 21.5 8 21.05 8 20.5V19.5H16V20.5C16 21.05 16.45 21.5 17 21.5H18C18.55 21.5 19 21.05 19 20.5V18.44C19.62 17.81 20 16.95 20 16V6.5C20 3 16.42 2.5 12 2.5ZM8.5 16.5C7.67 16.5 7 15.83 7 15C7 14.17 7.67 13.5 8.5 13.5C9.33 13.5 10 14.17 10 15C10 15.83 9.33 16.5 8.5 16.5ZM15.5 16.5C14.67 16.5 14 15.83 14 15C14 14.17 14.67 13.5 15.5 13.5C16.33 13.5 17 14.17 17 15C17 15.83 16.33 16.5 15.5 16.5ZM18 10.5H6V7.5H18V10.5Z',
      key: 'a3jisc',
    },
  ],
]);

export default DirectionsBusFilled;
